// components/VoiceSelector.js
import React from 'react';
import { MessageSquare } from 'lucide-react';
import { VOICE_STYLES } from '../promptTemplates/index_prompt_templates.js';

const VoiceSelector = ({ selectedVoice, onVoiceChange }) => {
  return (
    <div className="mb-4 bg-green-300 p-4 rounded-lg border border-green-400">
      <label className="block text-lg font-medium mb-2 flex items-center gap-2">
        <MessageSquare className="w-5 h-5 text-green-700" /> 
        AI Voice Style
      </label>
      
      <select
        value={selectedVoice}
        onChange={(e) => onVoiceChange(e.target.value)}
        className="w-full p-3 border border-green-400 rounded-lg bg-white text-lg"
      >
        {VOICE_STYLES.map((voice) => (
          <option key={voice.id} value={voice.id}>
            {voice.name} - {voice.description}
          </option>
        ))}
      </select>
    </div>
  );
};

export default VoiceSelector;